import { surveyElementsQueries } from '../queries/surveyElements.queries';
import { appQueryClient } from '~/adapters/reactQuery';

export const surveyElementsKeys = {
  fetchSurveyElementsBySurveys: ({ surveyIds }) => ['surveyElements', { surveyIds }],
  fetchSurveyToSurveyElements: ({ surveyId }) => ['surveyToSurveyElements', { surveyId }],
};

export const fetchSurveyElementsBySurveysQuery = async (surveyIds: number[]) => {
  return appQueryClient.fetchQuery({
    queryKey: surveyElementsKeys.fetchSurveyElementsBySurveys({ surveyIds }),
    queryFn: () => surveyElementsQueries.fetchSurveyElementsBySurveys(surveyIds),
    staleTime: 1000 * 60 * 5,
  });
};

export const fetchSurveyWithSurveyElements = async (surveyId: number) => {
  return appQueryClient.fetchQuery({
    queryKey: surveyElementsKeys.fetchSurveyToSurveyElements({ surveyId }),
    queryFn: () => surveyElementsQueries.fetchSurveyWithSurveyElements(surveyId),
    staleTime: 1000 * 60 * 5,
  });
};
